<template>
  <div class="navbar-header d-xl-block d-none">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <b-link
          class="navbar-brand"
          to="/"
        >
          <h5 class="mb-0 pb-0 font-weight-bolder font-medium-2 text-white">{{ userData ? userData.organisation_name : '' }}</h5>
        </b-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BLink,
  },
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      appName,
      appLogoImage,
    }
  },
}
</script>

<style>

</style>
